
import { Star, CheckCircle } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { GOOGLE_CALENDAR_LINK } from "@/lib/utils";
import { usePageContent } from "@/hooks/usePageContent";

export function HeroSection() {
  const { getText, get } = usePageContent('home');

  const crn        = getText('hero', 'crn',         'Nutricionista CRN 3/63492 · 6 anos de experiência');
  const title1     = getText('hero', 'title_1',     'Transforme sua');
  const title2     = getText('hero', 'title_2',     'relação com a comida.');
  const description= getText('hero', 'description', 'Acompanhamento nutricional humanizado para quem busca saúde de verdade. Sem restrições absurdas, sem culpa, com ciência e empatia.');
  const btnPrimary = getText('hero', 'btn_primary', 'Agendar Avaliação Gratuita →');
  const btnWpp     = getText('hero', 'btn_whatsapp','Falar no WhatsApp');
  const imageUrl   = (get('hero', 'image')?.content_value?.url as string) ?? '/camisa-preta.JPG';
  const benefitsRaw= get('hero', 'benefits')?.content_value?.items as string[] | undefined;
  const benefits   = benefitsRaw ?? [
    'Plano alimentar 100% personalizado',
    'Acompanhamento online ou presencial',
    'Sem dietas restritivas ou radicais',
  ];
  const statOfficesVal   = getText('hero', 'stat_offices_val',   '3');
  const statOfficesLabel = getText('hero', 'stat_offices_label', 'Consultórios\nem SP');
  const whatsappUrl      = getText('hero', 'whatsapp_url',       'https://wa.me/5511998874081');
  const btnPrimaryUrl    = getText('hero', 'btn_primary_url',    GOOGLE_CALENDAR_LINK);

  return (
    <section id="inicio" className="relative min-h-screen flex items-center overflow-hidden bg-white pt-20">
      <div className="absolute inset-y-0 left-0 w-full md:w-[70%] bg-brand-primary hidden md:block"
        style={{ clipPath: "polygon(0 0, 78% 0, 100% 100%, 0 100%)" }} />
      <div className="absolute inset-y-0 left-0 w-full bg-brand-primary md:hidden" />

      <div className="relative container mx-auto px-6 grid md:grid-cols-2 gap-0 items-center min-h-screen">
        <div className="py-20 md:py-0 pr-0 md:pr-16 space-y-8 z-10">
          <div className="inline-flex items-center gap-2 bg-white/15 border border-white/25 text-white/90 px-4 py-2 rounded-full text-xs font-bold font-primary tracking-wide uppercase">
            <Star className="w-3.5 h-3.5 fill-white text-white" />
            {crn}
          </div>

          <div>
            <span className="title-special text-4xl md:text-5xl text-white/70 block leading-none mb-2">
              {title1}
            </span>
            <h1 className="text-5xl md:text-6xl font-extrabold text-white font-primary leading-[1.05]">
              {title2.includes(' ') ? (
                <>
                  {title2.substring(0, title2.lastIndexOf(' ')+ 1)}
                  <span className="text-brand-softYellow">{title2.substring(title2.lastIndexOf(' ') + 1)}</span>
                </>
              ) : (
                <span className="text-brand-softYellow">{title2}</span>
              )}
            </h1>
          </div>

          <p className="text-white/75 text-lg leading-relaxed font-primary font-light max-w-md">
            {description}
          </p>

          <ul className="space-y-2">
            {benefits.map((b, i) => (
              <li key={i} className="flex items-center gap-2.5 text-white/85 text-sm font-primary">
                <CheckCircle className="w-4 h-4 text-brand-softYellow flex-shrink-0" />
                {b}
              </li>
            ))}
          </ul>

          <div className="flex flex-col sm:flex-row gap-3 pt-2">
            <a
              href={btnPrimaryUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-brand-secondary hover:bg-[#d4691f] text-white font-bold font-primary rounded-full px-8 py-4 text-base transition-all duration-200 shadow-xl shadow-brand-secondary/40 hover:scale-105 flex items-center justify-center gap-2"
            >
              {btnPrimary}
            </a>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white/30 text-white hover:bg-white/10 font-bold font-primary rounded-full px-8 py-4 text-base transition-all duration-200 flex items-center justify-center gap-2"
            >
              <FaWhatsapp className="w-5 h-5" />
              {btnWpp}
            </a>
          </div>
        </div>

        <div className="hidden md:block" />
      </div>

      <div className="absolute inset-y-0 right-0 w-[50%] hidden md:block">
        <img
          src={imageUrl}
          alt="Dra. Brenda Ramos - Nutricionista"
          className="w-full h-full object-cover object-top"
        />

        {(statOfficesVal || statOfficesLabel) && (
          <div className="absolute right-8 top-28 bg-brand-secondary text-white rounded-2xl shadow-2xl px-5 py-4 flex items-center gap-3">
            {statOfficesVal && (
              <p className="text-3xl font-extrabold font-primary leading-none">{statOfficesVal}</p>
            )}
            {statOfficesLabel && (
              <p className="text-xs font-primary text-white/80 leading-tight" style={{ whiteSpace: 'pre-line' }}>{statOfficesLabel}</p>
            )}
          </div>
        )}

      </div>
    </section>
  );
}
